//实际处理方法
import {
	removeToken
} from '../utils/auth.js'
export default {


	initSystemData(state, obj) {
		state.systemData = obj
	},
	Login(state, obj) {
		state.Login = obj
	},
	SetQuery(state, obj) {
		state.Query = obj
	},
	LogOut(state, obj) {
		state.Login = {}
		removeToken()
	},
	SetSearch(state, obj) {
		state.Search = obj
	},
	PushRouter(state, obj) {
		state.Router.push(obj)
	},
	BackRouter(state, obj) {
		state.Router.splice(state.Router.length - 1, 1)
	},
	SetLoanInfos(state, obj) {
		state.LoanInfos = obj
	},
	SetShowLoanInfo(state, obj) {
		state.ShowLoanInfo = obj
	},
	SetCompanyName(state, obj) {
		state.CompanyName = obj
	},
	SetPlatformType(state, obj) {
		state.platformType = obj
		state.platformTypeLoaded = true
	}

}


// WEBPACK FOOTER //
// ./src/store/mutations.js